<template>
  <div>
    <FusionBaseDialog
      @close="close"
      :open="open"
      :persistentOverlay="true"
      :max-width="550"
      :customCss="`register-multiple-devices ${step}`"
      padded
    >
      <template v-slot:header>
        <v-card-item>
          <v-card-title>
            {{ dialogTitle }}
          </v-card-title>
          <v-card-subtitle class="text-wrap">
            {{ dialogSubTitle }}
            <a
              v-if="downloadCsv"
              href="csv/Bulk device registration import template.csv"
              :aria-label="$t('registerMultipleDevices.downloadCsvFileAriaLabel')"
              class="download-link"
              download
            >
              {{ $t('registerMultipleDevices.downloadCsvFileText') }}
            </a>
          </v-card-subtitle>
        </v-card-item>
      </template>
      <DialogContent :cssStyle="cssStyle">
        <template v-slot:content>
          <slot name="content"></slot>
        </template>
      </DialogContent>
      <template v-slot:actions>
        <v-btn
          v-if="!removeCancelButton"
          @click="close"
          data-cy="registerMultipleClose"
          variant="outlined"
          class="text-black"
        >
          {{ $t('buttons.cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          data-cy="registerMultipleActionButton"
          color="primary"
          variant="flat"
          :disabled="disableActionButton"
          @click="onClickActionButton?.()"
        >
          <div class="trailing-icon-text">{{ dialogActionButtonText }}</div>
        </v-btn>
      </template>
    </FusionBaseDialog>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import DialogContent from './dialogContent.vue'

export default defineComponent({
  name: 'RegisterMultipleDevicesDialog',
  components: {
    DialogContent
  },
  props: {
    title: String,
    subTitle: String,
    downloadCsv: Boolean,
    open: Boolean,
    disableActionButton: Boolean,
    actionButtonText: String,
    onClickActionButton: Function as PropType<() => void>,
    cssStyle: String,
    step: String,
    removeCancelButton: Boolean
  },
  emits: ['close'],
  computed: {
    dialogTitle(): string {
      return this.title || String(this.$t('registerMultipleDevices.title'))
    },
    dialogSubTitle(): string {
      return this.subTitle || String(this.$t('registerMultipleDevices.subtitle'))
    },
    dialogActionButtonText(): string {
      return (
        this.actionButtonText || String(this.$t('registerMultipleDevices.addDevicesButtonText'))
      )
    }
  },
  methods: {
    close(): void {
      this.$emit('close')
    }
  }
})
</script>

<style lang="scss" scoped>
.download-link {
  text-decoration: underline;
  color: var(--tsi-color--main-primary);
  font-weight: 500;
  cursor: pointer;
}

.register-multiple-devices.validateCsv,
.register-multiple-devices.registerDevices {
  .v-card-subtitle {
    text-align: center;
    font-size: 1.2rem;
    padding-top: 2.4rem;
    color: var(--tsi-color--dark-76);
  }
}

.register-multiple-devices.showRegistrationResult {
  .v-card-subtitle {
    font-size: 1.2rem;
    color: var(--tsi-color--text-primary);
  }
}
</style>
